export const SUMMARY_INFO_REQUEST = "SUMMARY_INFO_REQUEST";
export const SUMMARY_INFO_SUCCESS = "SUMMARY_INFO_SUCCESS";
export const SUMMARY_INFO_FAILURE = "SUMMARY_INFO_FAILURE";
export const GET_RACKS_REQUEST = "GET_RACKS_REQUEST";
export const GET_RACKS_SUCCESS = "GET_RACKS_SUCCESS";
export const GET_RACKS_FAILURE = "GET_RACKS_FAILURE";
export const GET_RACK_REQUEST = "GET_RACK_REQUEST";
export const GET_RACK_SUCCESS = "GET_RACK_SUCCESS";
export const GET_RACK_FAILURE = "GET_RACK_FAILURE";
